import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";

const OrderTable = ({ order }) => {
  const [search, setSearch] = useState("");
  const [filterOrder, setFilterOrder] = useState("");

  const colums = [
    {
      name: "Order Number",
      selector: (row) => row.order_no,
      sortable: true,
    },
    {
      name: "Total Item",
      selector: (row) => row.order_details && row.order_details.length,
    },
    {
      name: "Amount",
      selector: (row) => row.total_amount,
    },
    {
      name: "Date",
      selector: (row) => row.order_date,
    },
    {
      name: "Satus",
      selector: (row) => row.delivery_status,
    },
    {
      name: "Action",
      selector: (row) => (
        <ul className="d-flex gap-2 list-unstyled mb-0">
          <li>
            <Link
              to={`/order-overview/${row.id}`}
              className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
            >
              <i className="fa fa-eye"></i>
            </Link>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    const result =
      order &&
      order.filter((data) => {
        const nameMatch = data.order_no
          .toLowerCase()
          .includes(search.toLowerCase());
        const idMatch = String(data.id).includes(search.toLowerCase());
        return nameMatch || idMatch;
      });
    setFilterOrder(result);
  }, [order, search]);

  return (
    <DataTable
      columns={colums}
      data={filterOrder}
      pagination
      fixedHeader
      fixedHeaderScrollHeight="450px"
      selectableRows
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={
        <input
          type="text"
          placeholder="Search here"
          className="w-25 form-control"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        ></input>
      }
      subHeaderAlign="left"
    />
  );
};

export default OrderTable;
